import axios from 'axios';
import { db, Pest } from '../db';

export interface PestRef { _id: string; code: string; name: string; }

export async function listPests(): Promise<PestRef[]> {
  const res = await axios.get('/api/v1/pests?enabledOnly=true', { withCredentials: true });
  return res.data as PestRef[];
}

export const syncPests = async (): Promise<void> => {
  const API_URL = process.env.REACT_APP_API_URL || '/api/v1';
  
  const response = await axios.get(`${API_URL}/pests?enabledOnly=true`, {
    withCredentials: true
  });
  const pests: any[] = response.data;

  const mappedPests: Pest[] = pests.map(p => ({
    id: p._id,
    code: p.code,
    name: p.name,
    order: p.order || 0,
    measurementType: p.measurementType as Pest['measurementType'] | undefined,
    displayPreference: p.displayPreference as Pest['displayPreference'] | undefined,
    aliases: Array.isArray(p.aliases) ? p.aliases : undefined,
    category: p.category as Pest['category'] | undefined,
    samplingUnit: p.samplingUnit as Pest['samplingUnit'] | undefined,
    tallyThreshold: p.tallyThreshold as Pest['tallyThreshold'] | undefined,
    actionThreshold: typeof p.actionThreshold === 'number' ? p.actionThreshold : undefined,
  }));

  // Clear existing pests and add new ones
  await db.pests.clear();
  await db.pests.bulkPut(mappedPests);
};
